<script>
import DefaultTable from './js'
export default DefaultTable
</script>

<style scoped>
@import "./scss/defaultTable.scss";
</style>
